import { formatMoney } from '@helpers/global'
import React, { useEffect } from 'react'

interface PitcoinLoginPromptProps {
  isCustomerLoggedIn: boolean
  subtotal: { amount: string; currencyCode: string }
  onVisibilityChange: (isVisible: boolean) => void
}

const PitcoinLoginPrompt: React.FC<PitcoinLoginPromptProps> = ({
  isCustomerLoggedIn,
  subtotal,
  onVisibilityChange,
}) => {
  const pitcoins = Math.round(Number(subtotal.amount) * 5) // Calculate Pitcoin™
  const dollarValue = (Number(subtotal.amount) * .05).toFixed(2) // Calculate dollar equivalent

  useEffect(() => {
    onVisibilityChange(!isCustomerLoggedIn)
    return () => onVisibilityChange(false) // Cleanup on unmount
  }, [isCustomerLoggedIn, onVisibilityChange])

  if (isCustomerLoggedIn) {
    return null // Hide on the cart page and if the customer is logged in
  }

  return (
    <div className="bg-gradient-yellow flex items-center justify-center p-2.5 gap-2 mt-2.5">
      <span className="body-xxs">💰</span>
      <p className="body-xxs font-medium text-black">
        <a href="/account" className="text-black underline">
          Login
        </a>{' '}
        to earn {pitcoins} Pitcoin™ (that's{' '}
        {formatMoney({
          amount: dollarValue,
          currencyCode: subtotal.currencyCode,
        }) || ''}
        )
      </p>
    </div>
  )
}

export default PitcoinLoginPrompt
